// Geometric constants for the MORPH-HEX tunnel.
//
// The player sits at world origin. The worldGroup (which holds all level
// geometry) is positioned so that one wall face is exactly under the player.
// Rotating the worldGroup around its Z axis brings a different face into
// "under the player" position.
//
// Local layout inside worldGroup:
//   - Tunnel center axis runs along worldGroup-local Z.
//   - Panels are arranged in a regular polygon around that axis. The
//     polygon's inscribed circle has radius APOTHEM, so each wall's
//     INNER (cavity-facing) surface is at distance APOTHEM from the axis.
//   - Panel index 0 is at LOCAL -Y direction (so it's the "floor" of the
//     cavity when worldGroup rotation is 0).
//   - Panel i is at local angular position alpha = i * (TAU / sides),
//     measured CCW (when looking from +Z) starting at the -Y axis.
//
// World placement:
//   - The player ball (radius PLAYER_RADIUS) is fixed at world (0, 0, 0).
//   - The polygon center (worldGroup origin) sits ABOVE the player. We need
//     the floor panel's inner face to land at world Y = -PLAYER_RADIUS so
//     the sphere rests with center at world origin.
//   - Floor panel inner face in worldGroup-local coords: y = -APOTHEM.
//   - Constraint: -APOTHEM + worldGroup.position.y = -PLAYER_RADIUS
//     -> worldGroup.position.y = APOTHEM - PLAYER_RADIUS.
//   - The cavity in world spans Y = -PLAYER_RADIUS .. (2*APOTHEM - PLAYER_RADIUS).
//   - worldGroup.position.z scrolls (increasing) over time, pulling segments
//     toward the player.

export const APOTHEM = 4.0;
export const WALL_THICKNESS = 0.4;
export const PLAYER_RADIUS = 0.45;

export const WORLD_Y_OFFSET = APOTHEM - PLAYER_RADIUS;

export const GRAVITY_MAGNITUDE = 22;

export function sideLengthFor(sides: number): number {
  return 2 * APOTHEM * Math.tan(Math.PI / sides);
}

export function radiusFor(sides: number): number {
  return APOTHEM / Math.cos(Math.PI / sides);
}
